module.exports = __webpack_public_path__ + "img/euro-dolar.8e687404.png";